import checkFeatureFlagParam from "./checkFeatureFlagParam";
import { getEnv, env } from "@/env";
import newrelic from "../monitoring/newrelic";
import { cache } from "react";

// Create a cached version of the function to fetch from the API
const fetchFeatureFlag = cache(
  async (flagKey: string, defaultValue: string) => {
    try {
      const response = await fetch(
        `${getEnv("NEXT_PUBLIC_SITE_URL", "https://www.edx.org")}/api/feature-flags?flagKey=${flagKey}&defaultValue=${encodeURIComponent(defaultValue)}`,
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching feature flag from API: ${response.status}`,
        );
      }

      const data = await response.json();
      return data.value;
    } catch (error) {
      newrelic.noticeError(error as Error, {
        message: "Error fetching feature flag from API",
        flagKey,
        defaultValue,
      });
      return defaultValue;
    }
  },
);

export async function evaluateFeatureFlag(
  flagKey: keyof typeof env,
  defaultValue: string,
): Promise<string> {
  // Check 1: Look for header value (from query params)
  const paramValue = await checkFeatureFlagParam(flagKey);
  if (paramValue !== null) {
    return paramValue;
  }

  // Check 2: Look for environment variable
  const envValue = getEnv(flagKey);
  if (envValue !== undefined) {
    return envValue as string;
  }

  // Check 3: Call API route which handles the Monarch API call with caching
  return await fetchFeatureFlag(flagKey as string, defaultValue);
}
